export function Notice({ kind, text }: { kind: "error" | "success" | "info"; text: string }) {
  const style =
    kind === "error"
      ? "bg-red-50 text-red-800 border-red-200"
      : kind === "success"
        ? "bg-green-50 text-green-800 border-green-200"
        : "bg-blue-50 text-blue-800 border-blue-200";
  return (
    <p
      role={kind === "error" ? "alert" : "status"}
      className={`rounded-lg border p-3 text-sm ${style}`}
    >
      {text}
    </p>
  );
}
